const initialState = {
  free_purchase_type: null
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case 'API:FETCH:FREE_PURCHASE_TPYE:SUCCESS':
      const { free_purchase_type } = action.response.data
      return { ...state, free_purchase_type }
    default:
      return { ...initialState, ...state }
  }
}

export default reducer
